(function(){
	'use strict';

	angular
		.module('app')
		.config(routes);

	function routes($stateProvider, $urlRouterProvider, $locationProvider) {
		$urlRouterProvider.otherwise('/');

		$stateProvider
			.state('main', {
				templateUrl: 'structure/main.template.html?v=0.1',
				controller: 'MainController',
				controllerAs: 'vm',
			})
			.state('home', {
				url: '/',
				templateUrl: 'layout/home/home.template.php',
				controller: 'HomeController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('about', {
				url: '/empresa',
				templateUrl: 'layout/about/about.template.html',
				controller: 'AboutController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('faq', {
				url: '/faq',
				templateUrl: 'layout/faq/faq.template.html',
				controller: 'FaqController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('access-panel', {
				url: '/area-restrita/login',
				templateUrl: 'layout/access-panel/access.login.template.html',
				controller: 'AccessPanelLoginController',
				controllerAs: 'vm',
				parent: 'main'
			})
			.state('access-panel-auth', {
				url: '/area-restrita/auth',
				templateUrl: 'layout/access-panel/access.login-auth.template.html',
				controller: 'AccessPanelLoginController',
				controllerAs: 'vm',
				parent: 'main',
				params: {isAuth: false},
				resolve: {
					checkUser: ($q, $stateParams, $state) => {
						var deferred = $q.defer();
						if($stateParams.isAuth){
							deferred.resolve('Acesso permitido.')
						}else{							
							deferred.reject('Acesso negado.');
							window.location.replace('area-restrita/login');

						}
						return deferred.promise;
					}
				}
			})

		$locationProvider.html5Mode(true);
	}

})();
